import React, { useCallback } from 'react';
import { styled } from '@mui/material';
import { GridReadyEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import BooleanCellRenderer from 'ui/AgGridReact/CellRenderers/BooleanCellRenderer';
import Flex from 'ui/Flex/Flex';
import { useGetColumnDefs } from './hooks/colDef';
import AddIntegrationButton from './AddIntegrationButton';
import { useGetClientIntegration } from './hooks/integrations';
import { getSoftwareDomain } from './helpers/getDomain';

const StyAgContainer = styled('div', {
    name: 'StyAgContainer',
    shouldForwardProp: (prop) => prop !== 'nbRows',
})<{ nbRows: number }>(({ nbRows }) => ({
    height: `${55 + nbRows * 50}px`, // We want to display about the header, 4 integrations (50px each) and we add 5px to prevent scroll
    maxWidth: '1000px',
    minHeight: '150px',
    marginBottom: '1rem',
}));

const IntegrationForm = ({
    isNew,
    bind,
    newSoftwares,
    setNewSoftwares,
}: {
    isNew: boolean;
    bind: string;
    newSoftwares: string[];
    setNewSoftwares: (newSoftwares: string[]) => void;
}) => {
    const colDefs = useGetColumnDefs(isNew);

    const { data: currentIntegrations } = useGetClientIntegration(bind);

    const onGridReady = (params: GridReadyEvent) => {
        params.api.autoSizeAllColumns();
    };

    const getRowData = useCallback(() => {
        const integrations = currentIntegrations
            ? currentIntegrations.sort((a, b) =>
                  a.software > b.software ? 1 : -1,
              )
            : [];
        const newIntegrations = newSoftwares.map((software) => ({
            software,
            function: getSoftwareDomain(software),
            isActive: false,
            lastExtractionDate: undefined,
            lastValidExtractionDate: undefined,
        }));
        return [...integrations, ...newIntegrations];
    }, [currentIntegrations, newSoftwares]);

    const rowData = getRowData();
    return (
        <Flex margin="10px" direction="column">
            <StyAgContainer
                className="ag-theme-material"
                nbRows={rowData.length}
            >
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    headerHeight={50}
                    rowHeight={50}
                    components={{
                        booleanCellRenderer: BooleanCellRenderer,
                    }}
                    onGridReady={onGridReady}
                    columnMenu="legacy"
                />
            </StyAgContainer>
            <AddIntegrationButton
                currentIntegrations={currentIntegrations || []}
                newSoftwares={newSoftwares}
                setNewSoftwares={setNewSoftwares}
            />
        </Flex>
    );
};
export default React.memo(IntegrationForm);
